export enum DoorSwingHingeSide {
  HingeLeft = 'hinge-left',
  HingeRight = 'hinge-right',
}
